// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as PartnerStatus from "../../partner/entity/PartnerStatus.bs.js";
import * as PartnerEngagement from "./PartnerEngagement.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function app_version_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var value = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict._0, "value"), null));
  if (value.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              value: value._0
            }
          };
  }
  var e = value._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".value" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function vehicle_stand_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var value = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict._0, "value"), null));
  if (value.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              value: value._0
            }
          };
  }
  var e = value._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".value" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function shift_timing_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var value = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict._0, "value"), null));
  if (value.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              value: value._0
            }
          };
  }
  var e = value._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".value" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function last_updated_at_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var value = Decco.optionFromJson(DeccoUtils$Catalyst.DateUtils.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "value"), null));
  if (value.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              value: value._0
            }
          };
  }
  var e = value._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".value" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var city = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "city"), null));
    if (city.TAG === /* Ok */0) {
      var msisdn = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "msisdn"), null));
      if (msisdn.TAG === /* Ok */0) {
        var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
        if (name.TAG === /* Ok */0) {
          var secondary_mobile = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "secondary_mobile"), null));
          if (secondary_mobile.TAG === /* Ok */0) {
            var status = PartnerStatus.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
            if (status.TAG === /* Ok */0) {
              var is_available = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_available"), null));
              if (is_available.TAG === /* Ok */0) {
                var vehicle_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_type"), null));
                if (vehicle_type.TAG === /* Ok */0) {
                  var engagement_type = PartnerEngagement.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "engagement_type"), null));
                  if (engagement_type.TAG === /* Ok */0) {
                    var app_version = app_version_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "app_version"), null));
                    if (app_version.TAG === /* Ok */0) {
                      var vehicle_stand = vehicle_stand_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_stand"), null));
                      if (vehicle_stand.TAG === /* Ok */0) {
                        var last_updated_at = last_updated_at_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "last_updated_at"), null));
                        if (last_updated_at.TAG === /* Ok */0) {
                          return {
                                  TAG: /* Ok */0,
                                  _0: {
                                    id: id._0,
                                    city: city._0,
                                    msisdn: msisdn._0,
                                    name: name._0,
                                    secondary_mobile: secondary_mobile._0,
                                    status: status._0,
                                    is_available: is_available._0,
                                    vehicle_type: vehicle_type._0,
                                    engagement_type: engagement_type._0,
                                    app_version: app_version._0,
                                    vehicle_stand: vehicle_stand._0,
                                    last_updated_at: last_updated_at._0
                                  }
                                };
                        }
                        var e = last_updated_at._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".last_updated_at" + e.path,
                                  message: e.message,
                                  value: e.value
                                }
                              };
                      }
                      var e$1 = vehicle_stand._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".vehicle_stand" + e$1.path,
                                message: e$1.message,
                                value: e$1.value
                              }
                            };
                    }
                    var e$2 = app_version._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".app_version" + e$2.path,
                              message: e$2.message,
                              value: e$2.value
                            }
                          };
                  }
                  var e$3 = engagement_type._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".engagement_type" + e$3.path,
                            message: e$3.message,
                            value: e$3.value
                          }
                        };
                }
                var e$4 = vehicle_type._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".vehicle_type" + e$4.path,
                          message: e$4.message,
                          value: e$4.value
                        }
                      };
              }
              var e$5 = is_available._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".is_available" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                      }
                    };
            }
            var e$6 = status._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".status" + e$6.path,
                      message: e$6.message,
                      value: e$6.value
                    }
                  };
          }
          var e$7 = secondary_mobile._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".secondary_mobile" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
        }
        var e$8 = name._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".name" + e$8.path,
                  message: e$8.message,
                  value: e$8.value
                }
              };
      }
      var e$9 = msisdn._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".msisdn" + e$9.path,
                message: e$9.message,
                value: e$9.value
              }
            };
    }
    var e$10 = city._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".city" + e$10.path,
              message: e$10.message,
              value: e$10.value
            }
          };
  }
  var e$11 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$11.path,
            message: e$11.message,
            value: e$11.value
          }
        };
}

export {
  app_version_decode ,
  vehicle_stand_decode ,
  shift_timing_decode ,
  last_updated_at_decode ,
  t_decode ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
